import React, { useEffect, useMemo, useState } from "react";
import { Card, Step, StepLabel, Stepper, useMediaQuery } from "@mui/material";
import actions from "../../Redux Store/actions";
import { useTheme } from "@mui/material/styles";
import { useDispatch } from "react-redux";
import Button from "../../Subcomponents/Button";
import cssClasses from "./EMandate.module.css";
import { numberWithCommas } from "../../Assets/Common/CommonFunctions";
import { useLocation, useNavigate } from "react-router-dom";
import PeopleOutlineIcon from "@mui/icons-material/PeopleOutline";
import EMandateStepper from "./EMandateStepper";
import {
  getApplicantsForEmandate,
  insertEmandateDetailsRecord,
} from "../../Services/Allotment";
import { dismissLoader, presentLoader } from "../../Services/loader";
import { set } from "lodash";

/* ---------------- STEPPER CONFIG (SAME AS SINGLE APPLICANT) ---------------- */

/* ---------------- BUTTON STYLES ---------------- */

const backBtnStyle = {
  height: "48px",
  borderRadius: "12px",
  border: "1px solid #d1d5db",
  backgroundColor: "#ffffff",
  color: "#0f172a",
  fontSize: "1.52rem",
};

const confirmBtnStyle = {
  height: "48px",
  borderRadius: "12px",
  fontSize: "1.52rem",
  color: "#ffffff",
};

/* ---------------- COMPONENT ---------------- */

const SplitAmount = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const totalMandateAmount = location.state?.totalMandateAmount || 0;
  const bookingId = location.state?.bookingId;
  const allotment = location.state?.allotment;
  const allotmentPaymentId = location.state?.allotmentPaymentId;

  // ✅ SAME ACTIVE STEP AS SINGLE APPLICANT
  const [activeStep] = useState(1);
  const [applicants, setApplicants] = useState([]);
  const [buttonText, setButtonText] = useState("Continue");

  const totalPercentage = useMemo(
    () =>
      applicants.reduce(
        (sum, singleApplicant) => sum + Number(singleApplicant.percentage || 0),
        0,
      ),
    [applicants],
  );

  const isValid = totalPercentage === 100;

  // handle percentage change for an applicant
  const handlePercentageChange = (id, value) => {
    // Ensure value is between 0 and 100
    // if (value < 0 || value > 100) return;

    // // Round the value to the nearest integer
    // const roundedValue = Math.round(Number(value));

    // // Ensure the value is an integer between 0 and 100
    // if (roundedValue < 0 || roundedValue > 100) return;
    // Remove leading zeros (except for '0' itself) and ensure value is between 0 and 100
    let sanitizedValue = value.replace(/^0+(?!$)/, ""); // Remove leading zeros, but allow '0'

    // If the value is empty after sanitization, set it to '0'
    if (sanitizedValue === "") {
      sanitizedValue = "0";
    }

    // Convert sanitized value to a number
    const numberValue = Number(sanitizedValue);

    // Ensure the value is a number between 0 and 100
    if (isNaN(numberValue) || numberValue < 0 || numberValue > 100) return;

    // Round the value to the nearest integer
    const roundedValue = Math.round(numberValue);

    setApplicants((prev) => {
      const updatedApplicants = [...prev];

      // Find the applicant whose percentage is being changed
      const updatedApplicant = updatedApplicants.find(
        (singleApplicant) => singleApplicant.id === id,
      );

      if (updatedApplicant) {
        updatedApplicant.percentage = roundedValue; // Use the rounded value
      }

      // Calculate the total percentage after the change
      const totalPercentage = updatedApplicants.reduce(
        (sum, singleApplicant) => sum + singleApplicant.percentage,
        0,
      );

      // Ensure the total percentage is 100, if not, adjust the other applicant's percentage
      if (totalPercentage !== 100) {
        const remainingPercentage = 100 - totalPercentage;

        // Find the other applicant and adjust their percentage
        const otherApplicant = updatedApplicants.find(
          (singleApplicant) => singleApplicant.id !== id,
        );
        if (otherApplicant) {
          otherApplicant.percentage =
            otherApplicant.percentage + remainingPercentage;
        }
      }

      console.log("updated applicants ---->", updatedApplicants);

      return updatedApplicants;
    });
  };

  // const handleConfirmSplit = async () => {
  //   console.log("applicants", applicants);
  //   // Step 1: Check if the total percentage of both applicants equals 100
  //   // const totalPercentage = applicants[0].percentage + applicants[1].percentage;

  //   // Step 2: Check if both applicants[0] and applicants[1] have the 'percentage' property
  //   if (applicants && applicants.length > 0) {
  //     let totalPercentage = 0;

  //     // Step 2: If applicants[1] exists, sum both percentages; if not, just use applicants[0]
  //     if (applicants[1]?.percentage) {
  //       totalPercentage = applicants[0].percentage + applicants[1].percentage;
  //     } else if (applicants[0]?.percentage) {
  //       totalPercentage = applicants[0].percentage;
  //     }

  //     console.log("Total Percentage:", totalPercentage);
  //     // Decide the value of isSplit
  //     const isSplit =
  //       totalPercentage === applicants[0].percentage ? false : true;

  //     console.log("isSplit:", isSplit);

  //     if (totalPercentage === 100) {
  //       // console.log(
  //       //   "Both applicants' total split ratio is 100, proceeding with registration.",
  //       // );

  //       // Step 2: Calculate the total mandate amount (assuming you have totalMandateAmount in your state)
  //       const totalMandateAmount = location.state?.totalMandateAmount || 0;

  //       // Step 3: Calculate the individual mandate amounts based on each applicant's percentage
  //       const updatedApplicants = applicants.map((applicant) => {
  //         const singleMandateAmount = Math.round(
  //           (totalMandateAmount * applicant.percentage) / 100,
  //         );
  //         applicant.amount = singleMandateAmount; // Update the amount for each applicant
  //         return applicant;
  //       });

  //       // Step 2: Insert eMandate details for both applicants in one request
  //       const insertPayload = updatedApplicants.map((applicant) => ({
  //         allotmentPaymentId: allotmentPaymentId,
  //         crmId: allotment?.CRM[0]?.id || null,
  //         name: applicant.name,
  //         pan: applicant.pan,
  //         splitRatio: applicant.percentage,
  //         emandateAmount: applicant.amount,
  //         emandateStatus: "Pending", // Set initial status to "Initiated"
  //         consumerId: `${bookingId || ""}${applicant?.pan || ""}`,
  //         // isSplit: applicant.percentage === 100 ? false : true,
  //         isSplit: isSplit,
  //       }));

  //       // console.log("Insert eMandate Details Payload:", insertPayload);

  //       const result = await insertEmandateDetailsRecord(insertPayload); // Function that inserts data into DB
  //       console.log("result----->", result);

  //       // If the insert is successful, proceed to the next page for the first applicant's registration
  //       const validResults = result.filter(
  //         (r) => r?.updatedData?.[0]?.splitRatio > 0,
  //       );

  //       if (Array.isArray(validResults) && validResults.length > 0) {
  //         const allInitiated = validResults.every((r) => r.isInserted === true);

  //         if (allInitiated) {
  //           // Navigate using FIRST valid applicant
  //           const firstValidApplicantIndex = result.findIndex(
  //             (r) => r?.updatedData?.[0]?.splitRatio > 0,
  //           );
  //           console.log("first valid - ", firstValidApplicantIndex);

  //           // Combine the updatedData with applicantData
  //           const combinedData = {
  //             ...result[firstValidApplicantIndex]?.updatedData[0], // Merging updatedData
  //             contactNumber:
  //               applicants[firstValidApplicantIndex]?.contactNumber, // Adding contact number
  //           };

  //           console.log("Combined Data: ", combinedData);

  //           // Navigate to the registration page with the combined data
  //           navigateToRegistrationPage(combinedData);
  //         } else {
  //           console.log("One or more valid applicants' mandates failed.");
  //         }
  //       } else {
  //         console.log("No valid applicants found (all split ratios are 0).");
  //       }
  //     } else {
  //       console.log("The total percentage of both applicants must equal 100.");
  //     }
  //   } else {
  //     console.log("Missing 'percentage' property for one or both applicants");
  //   }
  // };

  const handleConfirmSplit = async () => {
    console.log("applicants", applicants);
    presentLoader();

    try {
      // let totalPercentage = 0;

      // // Sum the percentages
      // applicants.forEach((applicant) => {
      //   totalPercentage += applicant.percentage || 0;
      // });

      // console.log("Total Percentage in split amount", totalPercentage);

      // // Decide the value of isSplit based on the total percentage
      // const isSplit =
      //   totalPercentage === applicants[0].percentage ? false : true;
      // console.log("isSplit in split amount :", isSplit);

      // const totalAmount = totalMandateAmount; // Total Amount
      // // const splitRatio = activeApplicant?.splitRatio; // Split ratio for active applicants
      // const splitRatio = applicants[0]?.percentage; // Split ratio for active applicants

      // // Calculate % of the total amount
      // const splitAmount = totalAmount * (splitRatio / 100);
      // console.log("Split Amount in split amount :", splitAmount);

      // // Now, applicants will include the new calculated properties
      // console.log("Updated applicants:", applicants);
      // console.log("navigating to next page....");

      let totalPercentage = 0;

      // Sum the percentages
      applicants.forEach((applicant) => {
        totalPercentage += applicant.percentage || 0;
      });

      console.log("Total Percentage in split amount", totalPercentage);

      // Decide the value of isSplit based on the total percentage
      const isSplit =
        totalPercentage === applicants[0].percentage ? false : true;
      console.log("isSplit in split amount :", isSplit);

      const totalAmount = totalMandateAmount; // Total Amount
      // Calculate splitAmount and splitRatio for each applicant
      const applicantsData = applicants.map((applicant) => {
        // Calculate split ratio and split amount for each applicant
        const splitRatio = applicant.percentage; // Split ratio is based on the applicant's percentage

        // Calculate split amount
        const splitAmount = (totalAmount * splitRatio) / 100;

        // Add the new properties to the applicant object
        return {
          ...applicant,
          splitAmount, // Add calculated split amount
          splitRatio, // Add split ratio
          calculatedPercentage: totalPercentage,
        };
      });

      console.log("Updated applicants:", applicantsData);

      // Navigating to the next page with updated applicants data
      console.log("Navigating to next page....");

      navigate("/Home/BankVerification", {
        state: {
          // splitData: data,
          currentIndex: 0, // 👈 start from first applicant
          currentApplicant: applicantsData, // 👈 only FIRST applicant now
          allotment,
          totalMandateAmount,
          bookingId,
          allotmentPaymentId,
        },
      });

      //  navigateToRegistrationPage(applicants);
      // Step 1: Check if the total percentage of both applicants equals 100
      // if (applicants && applicants.length > 0) {
      // let totalPercentage = 0;

      // // Sum the percentages
      // applicants.forEach((applicant) => {
      //   totalPercentage += applicant.percentage || 0;
      // });

      // console.log("Total Percentage:", totalPercentage);

      // // Decide the value of isSplit based on the total percentage
      // const isSplit =
      //   totalPercentage === applicants[0].percentage ? false : true;
      // console.log("isSplit:", isSplit);

      //   if (totalPercentage === 100) {
      //     // Step 2: Calculate the total mandate amount (assuming you have totalMandateAmount in your state)
      //     const totalMandateAmount = location.state?.totalMandateAmount || 0;

      //     // Step 3: Calculate the individual mandate amounts based on each applicant's percentage
      //     const updatedApplicants = applicants.map((applicant) => {
      //       const singleMandateAmount = Math.round(
      //         (totalMandateAmount * applicant.percentage) / 100,
      //       );
      //       applicant.amount = singleMandateAmount; // Update the amount for each applicant
      //       return applicant;
      //     });

      //     // Step 4: Filter out applicants with 0% split ratio if needed
      //     const filteredApplicants = updatedApplicants.filter(
      //       (applicant) => applicant.percentage > 0,
      //     );

      //     // Step 5: Insert eMandate details for the selected applicants in one request
      //     const insertPayload = filteredApplicants.map((applicant) => ({
      //       allotmentPaymentId: allotmentPaymentId,
      //       crmId: allotment?.CRM[0]?.id || null,
      //       name: applicant.name,
      //       pan: applicant.pan,
      //       splitRatio: applicant.percentage,
      //       emandateAmount: applicant.amount,
      //       emandateStatus: "Pending", // Set initial status to "Pending"
      //       consumerId: `${bookingId || ""}${applicant?.pan || ""}`,
      //       isSplit: isSplit, // This value determines whether it's split or not
      //     }));

      //     // console.log("Insert eMandate Details Payload:", insertPayload);

      //     const result = await insertEmandateDetailsRecord(insertPayload); // Function that inserts data into DB
      //     console.log("result----->", result);
      //     setButtonText("Confirm Split");
      //     // If the insert is successful, proceed to the next page for the first applicant's registration
      //     const validResults = result.filter((r) =>
      //       r?.insertedData?.[0]?.splitRatio > 0
      //         ? r?.insertedData?.[0]?.splitRatio > 0
      //         : r?.updatedData?.[0]?.splitRatio > 0,
      //     );

      //     if (Array.isArray(validResults) && validResults.length > 0) {
      //       const allInitiated = validResults.every(
      //         (r) => r.isInserted === true,
      //       );

      //       if (allInitiated) {
      //         // Navigate using FIRST valid applicant
      //         const firstValidApplicantIndex = result.findIndex((r) =>
      //           r?.insertedData?.[0]?.splitRatio > 0
      //             ? r?.insertedData?.[0]?.splitRatio > 0
      //             : r?.updatedData?.[0]?.splitRatio > 0,
      //         );
      //         // console.log("first valid - ", firstValidApplicantIndex);

      //         // Combine the updatedData with applicantData
      //         const combinedData = {
      //           ...result[firstValidApplicantIndex]?.updatedData[0], // Merging updatedData
      //           contactNumber:
      //             applicants[firstValidApplicantIndex]?.contactNumber, // Adding contact number
      //         };

      //         console.log("Combined Data: ", combinedData);

      //         // Navigate to the registration page with the combined data
      //         navigateToRegistrationPage(combinedData);
      //       } else {
      //         console.log("One or more valid applicants' mandates failed.");
      //       }
      //     } else {
      //       console.log("No valid applicants found (all split ratios are 0).");
      //     }
      //   } else {
      //     console.log(
      //       "The total percentage of both applicants must equal 100.",
      //     );
      //   }
      // } else {
      //   console.log("Missing 'percentage' property for one or both applicants");
      // }
    } catch (error) {
      console.error("Error in handleConfirmSplit:", error);
    } finally {
      dismissLoader();
    }
  };

  const navigateToRegistrationPage = (data) => {};

  useEffect(() => {
    dispatch(actions.activeMenu("emandateallotments"));
  }, [dispatch]);

  useEffect(() => {
    const fetchApplicants = async () => {
      try {
        console.log("SplitAmount → allotmentPaymentId:", allotmentPaymentId);

        if (!allotmentPaymentId) {
          console.warn("No allotmentPaymentId found");
          return;
        }

        const agreementForm =
          await getApplicantsForEmandate(allotmentPaymentId);

        console.log("SplitAmount → agreementForm:", agreementForm);

        const applicantsFromDB = agreementForm?.applicants || [];

        const equalPercentage = Math.floor(100 / applicantsFromDB.length);

        const mappedApplicants = applicantsFromDB.map((item, index) => {
          const singleApplicant = item.applicant;

          return {
            id: index + 1,
            name: singleApplicant.nameAsperPAN,
            pan: singleApplicant.panNumber,
            percentage: equalPercentage,
            nameAsPerPan: singleApplicant.nameAsperPAN,
            contactNumber: singleApplicant.contactNumber,
            email: singleApplicant.email,
          };
        });

        setApplicants(mappedApplicants);
      } catch (err) {
        console.error("Failed to fetch applicants for eMandate", err);
      }
    };

    fetchApplicants();
  }, [allotmentPaymentId]);

  return (
    <div style={{ overflow: "auto" }}>
      <div className={cssClasses.pageWrapper}>
        {/* ───────── STEPPER (IDENTICAL) ───────── */}
        <EMandateStepper activeStep={activeStep} />

        {/* ───────── CONTENT ───────── */}
        <div className={cssClasses.wrapper}>
          <div className={cssClasses.header}>
            <h2>E-Mandate Split Option</h2>
            <p>
              You have {applicants.length} applicants. Choose how to distribute
              the mandate.
            </p>
          </div>

          <Card className={cssClasses.amountCard} elevation={0}>
            <span>Total Mandate Amount</span>
            <strong>₹{numberWithCommas(totalMandateAmount)}</strong>
          </Card>
          <div className={cssClasses.splitHeader}>
            <h2>Enter Split Percentage</h2>
            <span
              className={`${cssClasses.totalBadge} ${
                isValid ? cssClasses.valid : cssClasses.invalid
              }`}
            >
              Total: {totalPercentage}%
            </span>
          </div>

          {!isValid && (
            <div className={cssClasses.errorBox}>
              Total percentage must equal 100%
            </div>
          )}

          {applicants.map((singleApplicant) => {
            const amountShare = Math.round(
              (totalMandateAmount * singleApplicant.percentage) / 100,
            );
            console.log("single applicant data ---->", singleApplicant);

            return (
              <Card key={singleApplicant.id} className={cssClasses.splitCard}>
                <div className={cssClasses.applicantInfo}>
                  <PeopleOutlineIcon />
                  <div>
                    <div className={cssClasses.applicantName}>
                      {singleApplicant.name}
                    </div>
                    <div className={cssClasses.applicantEmail}>
                      {singleApplicant.pan}
                    </div>
                  </div>
                </div>

                <div className={cssClasses.splitRow}>
                  <div className={cssClasses.inputGroup}>
                    <label>Percentage</label>
                    <div className={cssClasses.percentInput}>
                      <input
                        type="text" // Use text instead of number for better input handling
                        value={singleApplicant.percentage}
                        onInput={(e) =>
                          handlePercentageChange(
                            singleApplicant.id,
                            e.target.value,
                          )
                        }
                      />
                      <span>%</span>
                    </div>
                  </div>

                  <div className={cssClasses.inputGroup}>
                    <label>Amount Share</label>
                    <div className={cssClasses.amountBox}>
                      ₹{numberWithCommas(amountShare)}
                    </div>
                  </div>
                </div>
              </Card>
            );
          })}

          {/* ───────── FOOTER ───────── */}
          {/* <div className={cssClasses.footerRow}>
            <Button
              btnName="Back"
              style={backBtnStyle}
              clicked={() => navigate("/Home/EMandate")}
            />
            <Button
              btnName="Confirm Split"
              disable={!isValid}
              style={{
                ...confirmBtnStyle,
                backgroundColor: isValid ? "#163475ff" : "#94a3b8",
              }}
              clicked={handleConfirmSplit}
            />
          </div> */}
          <div className={cssClasses.footerRow}>
            <Button
              btnName="Back"
              style={backBtnStyle}
              clicked={() => navigate("/Home/EMandate")}
            />
            <Button
              // btnName="Confirm Split"
              btnName={buttonText}
              disable={!isValid}
              style={{
                ...confirmBtnStyle,
                backgroundColor: isValid ? "#163475ff" : "#94a3b8",
              }}
              clicked={handleConfirmSplit}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default SplitAmount;
